import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions, selectors } from '../../store/dux/n-protectant-dux';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import Map from './Map';
import FieldNProtectant from './FieldNProtectant';
import { Section } from '../Section';
import { useGrowers } from '../../hooks/use-growers';
import { useFields } from '../../hooks/use-fields';

export default function NProtectant() {
  const { selectedId: growerId } = useGrowers();
  const dispatch = useDispatch();
  const fields = useSelector(selectors.fields);
  const isLoading = useSelector(selectors.isLoading);
  const { selectedFields } = useFields();

  const reloadFields = useCallback(() => {
    if (growerId) dispatch(actions.loadNProtectantForGrower(growerId));
  }, [dispatch, growerId]);

  useEffect(() => {
    reloadFields();
  }, [growerId, reloadFields]);

  return (
    <Section>
      <ResizablePanel
        topPanel={buildTopPanel()}
        bottomPanel={buildBottomPanel()}
      />
    </Section>
  );

  function buildTopPanel() {
    return <Map />;
  }

  function buildBottomPanel() {
    return (
      <FieldNProtectant
        loading={isLoading}
        fields={fields || []}
        selectedFields={selectedFields}
        reloadFields={reloadFields}
      />
    );
  }
}
